import { authService } from '/assets/js/api/AuthService.js';

const form = document.getElementById('sign_in_form');
if (form) {
    const submitButton = document.getElementById('submitButton');
    const messageDiv = document.getElementById('message');

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        submitButton.disabled = true;
        submitButton.innerHTML = `<span class="kt-spinner kt-spinner-sm kt-spinner-light me-2"></span> Attendere...`;
        messageDiv.textContent = '';

        const email = document.getElementById('email').value;
        const password = document.getElementById('password').value;
        const remember = document.querySelector('input[name="remember"]').checked;

        try {
            await authService.login(email, password, remember);
            window.location.href = '/';
        } catch (error) {
            messageDiv.textContent = error.message || 'Si è verificato un errore imprevisto.';
            submitButton.disabled = false;
            submitButton.textContent = 'Login';
        }
    });
}
